module.exports = __webpack_public_path__ + "img/2021-09.d2be7429.jpg";